
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Category } from './useCategories';

interface CategoryWithActivity extends Category {
  last_activity_at: string | null;
}

export const useCategoriesByActivity = (parentId?: string | null, level?: number) => {
  return useQuery({
    queryKey: ['categories-by-activity', parentId, level],
    queryFn: async () => {
      console.log('Fetching categories by activity with parentId:', parentId, 'level:', level);
      
      // Use direct query instead of RPC (disabled - requires additional setup)
      let query = supabase
        .from('categories')
        .select('*')
        .order('last_post_at', { ascending: false, nullsFirst: false });
      
      if (parentId !== undefined) {
        if (parentId === null) {
          query = query.is('parent_category_id', null);
        } else {
          query = query.eq('parent_category_id', parentId);
        }
      }
      
      if (level !== undefined) {
        query = query.eq('level', level);
      }
      
      const { data, error } = await query;
      
      if (error) {
        console.error('Error fetching categories by activity:', error);
        throw error;
      }
      
      console.log('Categories by activity fetched:', data);
      return data as any[];
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
